import React, { Component } from "react";
import {  Route } from "react-router-dom";
import { StaticRouter } from "react-router";
import Components from "../ComponentIndex";

class ServerRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {}; 
  }

  render() {
    const date = new Date();
    const nanoSec = date.getMilliseconds();
    return (
      <StaticRouter>
        <section className="full-width-cont">
          {<Route exact key={nanoSec} path="**" component={Components[this.props.skin+"_MainLayout"]} />}
        </section>
      </StaticRouter>
    );
  }
}

export default ServerRoutes;
